/**
 * Api request pagination
 */
export class ApiRequestPagination {
	page!: number;
	pageSize!: number;
}
